export function isNullObject(obj: any) {
  return !(obj && Object.keys(obj).length);
}

export function getConfig(fieldName?: string) {
  const config = JSON.parse(sessionStorage.getItem('config') || '{}');
  if (fieldName) {
    return config?.[fieldName] ?? {};
  }
  return config;
}

// 서버에서 받아온 값과 정의된 constant 배열의 값이 일치할 경우 해당 label을 반환해준다.
export function getLabelWithConstant(options: any, value: string | number) {
  if (!options) return '';
  if (value || value === 0) {
    const label = options.find((item: any) => item.value === value)?.label;

    return label;
  }
  return '';
}

export function storageNullCheck(data: string | null) {
  switch (data) {
    case 'undefined':
    case 'null':
    case null:
      return false;
    default:
      return true;
  }
}

export const moveFocus = (targetElemId: string) => {
  document.getElementById(targetElemId)?.focus();
};
